/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AuthGetVerify = {
  id: 'authentication.verify.get',
  tag: 'Authentication',
  summary: 'Verify Users token',
  description: 'Users token verification',
  method: 'get',
  route: () => `/authentication/verify`,
  request: {
    query: z.strictObject({ token: z.string() }),
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
